const firebaseConfig = {
  apiKey: "AIzaSyAkZuTlEtmFVBYH4r1m3fGP4W6r63PvH5I",
  authDomain: "e-school-6e957.firebaseapp.com",
  projectId: "e-school-6e957",
  storageBucket: "e-school-6e957.appspot.com",
  messagingSenderId: "1039022408401",
  appId: "1:1039022408401:web:1d3340b811aed1d17f3bf0",
};

export default firebaseConfig;
